import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import {
  getFavoriteVenues, resetFavorites, utils,
} from '@resy/ui-kitchen';
import AmexShopSmallHeader from './AmexShopSmallHeader';
import AmexShopSmallBanner from './AmexShopSmallBanner';
import AmexShopSmallTerms from './AmexShopSmallTerms';
import AmexShopSmallBuyout from './AmexShopSmallBuyout';
import AmexShopSmallIntroBanner from './AmexShopSmallIntroBanner';
import AmexShopSmallSpendAndGet from './AmexShopSmallSpendAndGet';
import {
  DATE_TIMEFORMAT, TIMEZONE_EST, DEFAULT_CITY_CODE,
  DEFAULT_CITY_NAME, DEFAULT_COUNTRY, DURING_SHOPSMALL, BEFORE_SHOPSMALL, AFTER_SHOPSMALL,
} from './constants';
import currentTimeParserWithTimezone from './currentTimeParserWithTimezone';
import './AmexShopSmall.scss';
import { getResyLocationsThunk } from '../../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

class AmexShopSmall extends React.Component {
  static propTypes = {
    $rootScope: PropTypes.shape({
      $broadcast: PropTypes.func,
      isScrolled: PropTypes.bool,
      nav: PropTypes.shape(),
      previewMode: PropTypes.bool,
      $digest: PropTypes.func,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    ResyAmexConfig: PropTypes.shape({
      baseRequestUrl: PropTypes.string.isRequired,
    }).isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    showSignupModal: PropTypes.func.isRequired,
    $location: PropTypes.shape({
      path: PropTypes.func,
      search: PropTypes.func.isRequired,
    }).isRequired,
    loadNotifyModal: PropTypes.func.isRequired,
    Analytics: PropTypes.shape({ event: PropTypes.func.isRequired }).isRequired,
    showAuthModal: PropTypes.func.isRequired,
    favoriteVenues: PropTypes.shape({
      loaded: PropTypes.bool,
      venueIds: PropTypes.arrayOf(PropTypes.number),
      venues: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    dispatch: PropTypes.func.isRequired,
    $window: PropTypes.shape({}).isRequired,
    userLocation: PropTypes.shape({
      countryCode: PropTypes.string,
    }).isRequired,
  }

  static defaultProps = {
    favoriteVenues: null,
  };

    state = {
      dataContent: {},
      editorialsOffer: {},
      editorialsBuyout: {},
      termsActive: false,
      termsHeight: '0px',
      hash: null,
      hashList: [],
      favoriteVenueIds: [],
    }

    componentDidMount = async () => {
      const currentHash = (window.location.hash).replace('#', '');
      window.addEventListener('hashchange', this.handleHashChange, false);
      this.fetchConfig(currentHash);
      this.checkShowSignupModal();
      try {
        await this.fetchFavoriteVenues();
      } catch (err) {
        Logger.error('[AmexShopSmall] Error saving favorite venue on mount', err);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      const { hash, hashList } = this.state;
      if (prevState.hash !== hash) {
        window.location.hash = hash;
        if (hash) {
          if (hashList) {
            this.toggleTerms(hash);
            setTimeout(() => {
              this.scrollTo(`#${hash}`);
            }, 1000);
          } else {
            setTimeout(() => {
              this.scrollTo(`#${hash}`);
            }, 1000);
          }
        }
      }
      const {
        favoriteVenues,
      } = this.props;
      if (prevProps.favoriteVenues !== favoriteVenues) {
        this.setVenueIds(favoriteVenues);
      }
    }

    componentWillUnmount() {
      window.removeEventListener('hashchange', this.handleHashChange, false);
    }

    setVenueIds = (favoriteVenues) => {
      const {
        venueIds,
      } = favoriteVenues;
      this.setState({ favoriteVenueIds: venueIds });
    }

    fetchFavoriteVenues = async () => {
      const {
        dispatch,
        isAuthenticated,
      } = this.props;

      if (isAuthenticated) {
        dispatch(getFavoriteVenues());
      } else {
        dispatch(resetFavorites());
      }
    }

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');
    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  }

  toggleTerms = (hashValue) => {
    const { termsActive } = this.state;

    const termsContent = document.querySelector('.AmexShopSmallTerms__Terms__text');
    if (termsContent !== null) {
      if (hashValue) {
        this.setState({
          termsActive: true,
          termsHeight: `${termsContent.scrollHeight + 50}px`,
        });
      } else {
        this.setState({
          termsActive: !termsActive,
          termsHeight: termsActive ? '0px' : `${termsContent.scrollHeight + 50}px`,
        });
      }
    }
    return false;
  };

  fetchConfig = async (hash) => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    const dataEndPoint = `${baseRequestUrl}ShopSmall/ShopSmallData.json`;
    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const dataContent = await dataResponse.json();
      const {
        terms: {
          hashList,
        },
      } = dataContent;
      this.setState({ dataContent, hashList, hash });
      await this.loadDefaultCityCode(dataContent);
      await this.fetchOfferEditorials();
      await this.fetchBuyoutEditorials();
    } catch (err) {
      Logger.error('[AmexShopSmall] AmexShopSmall JSON File Error :', err);
    }
  }

  fetchOfferEditorials = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    const dataEndPoint = `${baseRequestUrl}ShopSmall/editorialData/spendAndGet/offers_editorial.json`;
    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const editorialsOffer = await dataResponse.json();
      this.setState({ editorialsOffer });
    } catch (err) {
      Logger.error('[AmexShopSmall] AmexShopSmall JSON File Error:', err);
    }
  }

  fetchBuyoutEditorials = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    const dataEndPoint = `${baseRequestUrl}ShopSmall/editorialData/buyout/buyout_editorial.json`;
    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const editorialsBuyout = await dataResponse.json();
      this.setState({ editorialsBuyout });
    } catch (err) {
      Logger.error('[AmexShopSmall] AmexShopSmall JSON File Error:', err);
    }
  }

  checkShowSignupModal = () => {
    const { showSignupModal } = this.props;
    const isSignUp = utils.getQueryVariable('signup');

    if (isSignUp === 'true') {
      showSignupModal();
    }
  }

  login = (eventName, eventCategory, eventLabel) => {
    const { $rootScope, Analytics } = this.props;
    Analytics.event(eventName, {
      category: eventCategory,
      label: eventLabel,
    });
    $rootScope.$broadcast('MODAL', 'signin');
  }

  handleTagging = (eventName) => {
    const { Analytics } = this.props;
    const params = {
      context: 'Shop Small Page',
      category: 'Shop Small Interaction',
    };
    Analytics.event(eventName, params);
  }

  scrollTo = (link) => {
    // keyboard support for tab focus
    const id = link.replace('#', '');
    const target = document.getElementById(id);
    // all targets on the page are non focusable sections. Add tabindex, then set focus
    target.setAttribute('tabindex', '-1');
    setTimeout(() => target.focus(), 0);
    document.querySelector(link).scrollIntoView({ behavior: 'smooth' });
  }

  loadCityCodeAsParam = (dataContent) => {
    const { $location } = this.props;
    let defaultCity = null;
    const { city: cityValue } = $location.search();
    if (cityValue) {
      const matchCity = this.getCityVenueIds(cityValue, dataContent);
      if (matchCity && matchCity.code) {
        defaultCity = { code: matchCity.code, name: matchCity.name };
      } else {
        defaultCity = { code: DEFAULT_CITY_CODE, name: DEFAULT_CITY_NAME };
      }
      this.setState({ defaultCity });
    }
    return defaultCity;
  }

  loadDefaultCityCode = async (dataContent) => {
    const { userLocation } = this.props;
    const { dispatch } = this.props;
    let defaultCity = {};
    if (!this.loadCityCodeAsParam(dataContent)) {
      if (userLocation?.countryCode === DEFAULT_COUNTRY) {
        let locationCode = '';
        try {
          locationCode = await dispatch(getResyLocationsThunk('nearest'));
        } catch (err) {
          Logger.error('Error --', err);
        }

        if (!locationCode) {
          defaultCity = { code: DEFAULT_CITY_CODE, name: DEFAULT_CITY_NAME };
        } else {
          const matchCity = this.getCityVenueIds(locationCode, dataContent);
          if (matchCity && matchCity.code) {
            defaultCity = { code: matchCity.code, name: matchCity.name };
          } else {
            defaultCity = await this.loadClosestCityCode(dataContent);
          }
        }
      } else {
        defaultCity = { code: DEFAULT_CITY_CODE, name: DEFAULT_CITY_NAME };
      }
      this.setState({ defaultCity });
    }
  }

 loadClosestCityCode = async (dataContent) => {
   const { dispatch } = this.props;
   let defaultCity = {};
   let locations = [];
   try {
     locations = await dispatch(getResyLocationsThunk('all'));
   } catch (err) {
     Logger.error('Error --', err);
   }

   if (locations.length) {
     let i = 0;
     let closestCity = {};
     for (i; i < locations.length; i++) {
       const locationCodeValue = locations[i].code;
       closestCity = this.getCityVenueIds(locationCodeValue, dataContent);
       if (closestCity && closestCity.code) {
         defaultCity = { code: closestCity.code, name: closestCity.name };
         break;
       }
     }
   }

   return defaultCity;
 }

 getCityVenueIds = (cityCode, dataContent) => {
   let cityVenueIds = '';
   const {
     spend_and_get: {
       city_venue_mappings: cityVenueMappings,
     },
   } = dataContent;

   cityVenueIds = cityVenueMappings.find((itemValue) => itemValue.code === cityCode);
   return cityVenueIds;
 }

 findShopSmallEventTiming = () => {
   const {
     dataContent: {
       start_date_time: startDateTime,
       end_date_time: endDateTime,
     },
   } = this.state;

   let eventTiming = '';

   const parseCurrentDate = currentTimeParserWithTimezone(TIMEZONE_EST);
   const parsedEndDate = moment(endDateTime, DATE_TIMEFORMAT);
   const parsedStartDate = moment(startDateTime, DATE_TIMEFORMAT);

   if (parseCurrentDate.isSameOrAfter(parsedStartDate) && parseCurrentDate.isSameOrBefore(parsedEndDate)) {
     eventTiming = DURING_SHOPSMALL;
   } else if (parseCurrentDate.isAfter(parsedEndDate)) {
     eventTiming = AFTER_SHOPSMALL;
   } else {
     eventTiming = BEFORE_SHOPSMALL;
   }
   return eventTiming;
 }

 render() {
   const {
     matchMedia,
     ResyAmexConfig: {
       baseRequestUrl,
     },
     $location,
     $window,
     loadNotifyModal,
     $rootScope,
     Analytics,
     isAuthenticated,
     showSignupModal,
     showAuthModal,
   } = this.props;

   const {
     dataContent,
     defaultCity,
     editorialsOffer,
     editorialsBuyout,
     termsHeight,
     termsActive,
     favoriteVenueIds,
   } = this.state;

   if (Object.keys(dataContent).length === 0) return null;

   const {
     is_page_enabled: isPageEnabled = false,
     header: headerConfig,
     banner: bannerConfig,
     terms: termsConfig,
     buyout: buyoutConfig,
     intro_banner: introConfig,
     tagging: taggingConfig,
     spend_and_get: spendAndGetConfig,
     enroll_offer: enrollOfferConfig,
   } = dataContent;

   if (!isPageEnabled) {
     // 404 path
     $location.path('/404');
     $rootScope.$digest();
   }

   const hideIntroBannerNow = introConfig?.hide_section;
   const hideTerms = termsConfig?.hide_section;
   const hideSpendAndGet = spendAndGetConfig?.hide_section;
   const hideEnrollOffer = enrollOfferConfig?.hide_section;
   const hideBuyout = buyoutConfig?.hide_section;

   if (!bannerConfig) {
     return null;
   }

   const eventTiming = this.findShopSmallEventTiming();
   return (
     <div className="AmexShopSmall">
       <AmexShopSmallHeader
         headerConfig={headerConfig}
         Analytics={Analytics}
         isAuthenticated={isAuthenticated}
         $rootScope={$rootScope}
         handleTagging={this.handleTagging}
         $location={$location}
         matchMedia={matchMedia}
         tagConfig={taggingConfig}
       />
       <AmexShopSmallBanner
         matchMedia={matchMedia}
         bannerConfig={bannerConfig}
         baseRequestUrl={baseRequestUrl}
         eventTiming={eventTiming}
       />
       {!hideIntroBannerNow && (
       <AmexShopSmallIntroBanner
         eventTiming={eventTiming}
         introConfig={introConfig}
         isAuthenticated={isAuthenticated}
         handleTagging={this.handleTagging}
         login={this.login}
         scrollTo={this.scrollTo}
         showSignupModal={showSignupModal}
         tagConfig={taggingConfig}
         toggleTerms={this.toggleTerms}
         baseRequestUrl={baseRequestUrl}
       />
       )}

       {!hideSpendAndGet && defaultCity && (
       <AmexShopSmallSpendAndGet
         baseRequestUrl={baseRequestUrl}
         spendAndGetConfig={spendAndGetConfig}
         defaultCity={defaultCity}
         matchMedia={matchMedia}
         $rootScope={$rootScope}
         $location={$location}
         $window={$window}
         Analytics={Analytics}
         taggingConfig={taggingConfig}
         loadNotifyModal={loadNotifyModal}
         eventTiming={eventTiming}
         editorialConfig={editorialsOffer}
         handleTagging={this.handleTagging}
         enrollOfferConfig={enrollOfferConfig}
         scrollTo={this.scrollTo}
         hideEnrollOffer={hideEnrollOffer}
         toggleTerms={this.toggleTerms}
         showAuthModal={showAuthModal}
         favoriteVenueIds={favoriteVenueIds}
       />
       )}

       {!hideBuyout && !(eventTiming === AFTER_SHOPSMALL) && (
         <AmexShopSmallBuyout
           $location={$location}
           $rootScope={$rootScope}
           loadNotifyModal={loadNotifyModal}
           buyoutConfig={buyoutConfig}
           baseRequestUrl={baseRequestUrl}
           editorialConfig={editorialsBuyout}
           handleTagging={this.handleTagging}
           Analytics={Analytics}
           taggingConfig={taggingConfig}
           scrollTo={this.scrollTo}
           toggleTerms={this.toggleTerms}
           showAuthModal={showAuthModal}
           favoriteVenueIds={favoriteVenueIds}
           matchMedia={matchMedia}
         />
       )}

       {!hideTerms && !(eventTiming === AFTER_SHOPSMALL) && (
       <AmexShopSmallTerms
         termsConfig={termsConfig}
         toggleTerms={this.toggleTerms}
         termsHeight={termsHeight}
         termsActive={termsActive}
       />
       )}
     </div>
   );
 }
}

const mapStateToProps = (state) => ({
  favoriteVenues: state.favorite,
  isAuthenticated: selectIsAuthenticated(state),
  userLocation: state.ipdata,
});

AmexShopSmall.displayName = 'AmexShopSmall';
export { AmexShopSmall as ComponentAmexShopSmallUnderTest };
export default connect(mapStateToProps)(AmexShopSmall);
